// PATH: src/routes/ProtectedRoute.tsx — garde des routes authentifiées.
// Aligné sur tc_tilmicode_ui/src/routes/ProtectedRoute.tsx.
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Spin } from "antd";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { status } = useAuth();
  const location = useLocation();

  // Session pas encore vérifiée : ne rien trancher. Afficher l'application
  // maintenant la ferait clignoter avant la redirection ; rediriger tout de
  // suite déconnecterait un utilisateur pourtant valide.
  if (status === "unknown") {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (status === "anonymous") {
    // `from` permet de revenir à la page demandée après connexion : un lien
    // vers /students/17 reçu par message ne doit pas atterrir sur la liste.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
